import { render, staticRenderFns } from "./CandidateJoining.vue?vue&type=template&id=4fe77d82&scoped=true"
import script from "./CandidateJoining.vue?vue&type=script&lang=js"
export * from "./CandidateJoining.vue?vue&type=script&lang=js"
import style0 from "./CandidateJoining.vue?vue&type=style&index=0&id=4fe77d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe77d82",
  null
  
)

export default component.exports